export default __webpack_public_path__ + "static/media/qamar.e642b815.jpeg";